import type { GaiaMessageType } from "./gaia";

export interface Device {
    name: string;
    id: string;
    specifications: string;
    model: string;
    osType: string;
    oem: string;
    source: string;
    releaseYear: string;
}

export interface ExternalDevice {
    name: string;
    deviceReferenceId: string;
    specifications: string;
    model: string;
    osType: string;
    osVersion: string;
    osVersionName: string;
    oem: string;
    source: string;
    thumbnailLink: string;
    deviceImageLink: string;
    models: string[];
    osVersions: OsVersion[];
    releaseYear: string;
}

interface OsVersion {
    versionId: 0;
    name: string;
    locale: string;
    osVersionName: string;
    osVersion: string;
    lastUpdatedDate: string;
    tutorialLink: string;
}

export interface Tutorial {
    source: string;
    answerId: string;
    answerUrl: string;
    name: string;
    description: string;
    osVersion: string;
    tutorialBaseUrl: string;
}

export interface MultiModal {
    title: string;
    collage: string;
    collection: Record<number, string>;
}

export interface Citation {
    type: string;
    uri: string;
    title: string;
    domain: string;
}

// Search & Proactive messages come from gaia
// others are custom message types to be handled within the Timeline
export type MessageType =
    | GaiaMessageType
    | "Expert"
    | "Default"
    | "Error"
    | "Connection"
    | "SessionSummary"
    | "QuickAction"
    | "Separator"
    | "GuideRecommendation"
    | "Generic"
    | "SalesGuidance"
    | "SalesMessage"
    | "SmartOffer"
    | "SmartOfferGeneric"
    | "SmartOfferResponse";

export type MessageSubType = "offer" | "enrollment" | "celebratory" | "waitingEnrollment";

export interface SendMessageBaseProps {
    id?: string;
    text: string;
    source?: string;
    type: MessageType;
}
export type SendExpertAssistMessage = (props: SendMessageBaseProps) => void;

// drag related types - notepad, ozmo iframe
export interface Coordinates {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
}

export interface Location {
    x: number;
    y: number;
}

export interface Size {
    width: number;
    height: number;
}

export type SmartOfferActions = {
    handleChatDeclineOffer?: (messageId?: string) => void | Promise<void>;
    handleChatSendToCustomer?: (messageId?: string) => void | Promise<void>;
    handleChatSendEnrollment?: (messageId?: string) => void | Promise<void>;
    handleResendDisclosureLink?: (messageId?: string) => void | Promise<void>;
    handlePreviewDisclosures?: () => void | Promise<void>;
    isResendLinkLoading?: boolean;
    isMaxAttemptsReached?: boolean;
    isSmartOfferActionUsed?: (actionId: string) => boolean;
};
